import { ABTestId } from '@src/services/mobility-bonus/shared/utils/abTest/abTestVariants'
import { calculateImageSize } from '@src/services/mobility-bonus/shared/utils/calculateImageSizeByHeight'
import { MESSAGE } from '@src/shared/constants/alert'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { Player } from '@lottiefiles/react-lottie-player'
import CurrentStateSection from '../../shared/components/CurrentStateSection'
import Alert from '../../shared/components/Modal/Alert'
import { ROUTE_PATH } from '../../shared/constants/routePath'
import { AB_TEST_ID_PARAM_KEY } from '@src/services/mobility-bonus/shared/utils/abTest/abTestUtils'
import { Icon } from '@socar-inc/socar-design-system-for-migration'

export interface IntroProps {
  referralCode: string
  abTestId: ABTestId | null
}

const Intro = ({ referralCode, abTestId }: IntroProps) => {
  const router = useRouter()
  const [open, setOpen] = useState(false)

  const closeAlert = () => {
    setOpen(false)
  }

  const handleMoveToLink = () => {
    const AIR_BRIDGE_URL = process.env.NEXT_PUBLIC_AIR_BRIDGE_URL

    if (referralCode && AIR_BRIDGE_URL) {
      const targetUrl = new URL(ROUTE_PATH.BRIDGE, location.origin)
      targetUrl.searchParams.set('referralCode', referralCode)
      if (abTestId) {
        targetUrl.searchParams.set(AB_TEST_ID_PARAM_KEY, abTestId)
      }

      const airBridgeUrl = new URL(AIR_BRIDGE_URL)
      airBridgeUrl.searchParams.set('url', targetUrl.toString())
      // after-login=true은 네이티브에서 사용하는 값으로 인코딩x
      airBridgeUrl.searchParams.set('after-login', 'true')

      return router.replace(airBridgeUrl.toString())
    }

    const BRANCH_URL = process.env.NEXT_PUBLIC_BRANCH_URL
    if (BRANCH_URL) {
      return router.replace(BRANCH_URL)
    }
    setOpen(true)
  }

  const isIntroWebOnly = !!referralCode

  return (
    <>
      <div className="tw-flex tw-w-full tw-flex-col tw-justify-center">
        <div className="tw-aspect-[375/544]">
          <Player
            autoplay
            loop
            src="/lotties/mobility-bonus/v250520/mobility_bonus_event.json"
          />
        </div>
        <Image
          src={
            isIntroWebOnly
              ? '/images/mobility-bonus/v250520/intro/intro_web_only_1.png'
              : '/images/mobility-bonus/v250520/intro/intro_1.png'
          }
          alt="이동 지원금 혜택안내"
          {...calculateImageSize({ height: 494 })}
          className="tw-h-full tw-w-full"
        />
        {!isIntroWebOnly && (
          <>
            <Image
              src="/images/mobility-bonus/v250520/intro/intro_4.png"
              alt="더 많은 혜택 안내"
              {...calculateImageSize({ height: 592 })}
              className="tw-h-full tw-w-full"
            />
            <button onClick={handleMoveToLink}>
              <Image
                src="/images/mobility-bonus/v250520/intro/intro_5.png"
                alt="이벤트 참여하기 버튼"
                {...calculateImageSize({ height: 64 })}
                className="tw-h-full tw-w-full"
              />
            </button>
            <Image
              src="/images/mobility-bonus/v250520/intro/intro_6.png"
              alt="하단 이미지"
              {...calculateImageSize({ height: 80 })}
              className="tw-h-full tw-w-full"
            />
            <Image
              src="/images/mobility-bonus/v250520/intro/intro_7.png"
              alt="이용약관"
              {...calculateImageSize({ height: 487 })}
              className="tw-h-full tw-w-full"
            />
          </>
        )}

        {/* CTA 버튼 영역 */}
        {isIntroWebOnly && (
          <>
            <section className="tw-bottom-spacing-0 tw-px-spacing-600 tw-pb-spacing-600 tw-fixed tw-flex tw-w-full tw-min-w-[320px] tw-max-w-[420px] tw-flex-col tw-items-end tw-bg-white">
              <button
                onClick={handleMoveToLink}
                className="tw-bg-blue-500 tw-py-spacing-500 tw-text-fontsize-18 tw-rounded-radius-200 tw-font-fontweight-semiBold tw-flex tw-w-full tw-items-center tw-justify-center tw-text-white">
                이동지원금 받으러 가기
                <Icon icon="ic18_chevron_right" color="white" />
              </button>
            </section>
            <div className="tw-h-[84px]" />
          </>
        )}
      </div>
      {open && (
        <Alert {...MESSAGE.ERROR} onClose={closeAlert} onConfirm={closeAlert} />
      )}
    </>
  )
}

export default Intro
